import { useState } from 'react';

/**
 * Отметка «это я уже видел» для значков в шапке: уведомлений и «Что нового».
 *
 * Хранится в localStorage — это состояние конкретного браузера, серверу знать
 * о нём незачем. Запрет хранилища (приватный режим) не должен ничего ломать:
 * тогда отметка просто не переживает перезагрузку, и значок появится снова.
 */
export function useSeenMarker(key: string): {
  /** Что было отмечено прочитанным в прошлый раз; null — ничего. */
  seen: string | null;
  markSeen: (value: string) => void;
} {
  const [seen, setSeen] = useState<string | null>(() => {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  });

  const markSeen = (value: string) => {
    setSeen(value);
    try {
      localStorage.setItem(key, value);
    } catch {
      // Не смогли запомнить — значок вернётся после перезагрузки.
    }
  };

  return { seen, markSeen };
}
